<template>
  <button
    :disabled="disabled || loading"
    type="button"
    :class="type"
    :aria-describedby="ariaDescribedby"
  >
    <span
      v-if="loading"
      class="fa-regular fa-circle-notch fa-spin"
      aria-hidden="true"
    />
    <i
      v-else-if="icon"
      :class="icon"
    />
    <span :class="{ 'ms-1': !!icon || !!loading }"><slot /></span>
  </button>
</template>

<script lang="ts" setup>
  import { VueButtonTypes } from '@/VueComponents/SharedComponents/Buttons/Enums/VueButtonTypes';

  withDefaults(defineProps<{
    type?: VueButtonTypes,
    loading?: boolean,
    disabled?: boolean,
    icon?: string,
    ariaDescribedby?: string,
    additionalButtonClass?: string
  }>(), { loading: false, disabled: false, icon: '', type: VueButtonTypes.default, ariaDescribedby: '', additionalButtonClass: '' });
</script>
